export var ACTION;
(function (ACTION) {
    ACTION["ON_SAVE"] = "ON_SAVE";
    ACTION["ON_SKIP"] = "ON_SKIP";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["SHARE"] = "SHARE";
    ACTION["GO_CAMS"] = "GO_CAMS";
    ACTION["GO_KARVY"] = "GO_KARVY";
    ACTION["GO_OPERATIONAL"] = "GO_OPERATIONAL";
})(ACTION || (ACTION = {}));
